import type { ReactNode } from 'react';
import { motion } from 'motion/react';

interface PageLayoutProps {
    title: string;
    description?: string;
    action?: ReactNode;
    children: ReactNode;
}

export const PageLayout = ({ title, description, action, children }: PageLayoutProps) => {
    return (
        <div className="flex flex-col h-full bg-slate-50 dark:bg-slate-950">
            {/* Page Header */}
            {/* Page Header */}
            <motion.div 
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, ease: 'easeOut' }}
                className="shrink-0 px-4 lg:px-8 py-6 max-w-7xl mx-auto w-full"
            >
                <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                    <div>
                        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">{title}</h1>
                        {description && (
                            <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{description}</p>
                        )}
                    </div>
                    {action && (
                        <div className="shrink-0">
                            {action}
                        </div>
                    )}
                </div>
            </motion.div>

            {/* Page Content */}
            {/* Page Content */}
            <motion.div 
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.1, ease: 'easeOut' }}
                className="flex-1 px-4 lg:px-8 pb-8 max-w-7xl mx-auto w-full"
            >
                {children}
            </motion.div>
        </div>
    );
};
